



<mat-drawer-container class="search-container" autosize>
  <div class="example-loading-shade" *ngIf="isLoadingResults"></div>

  <mat-drawer #drawer class="search-sidenav p-2" [mode]="isLargeScreen() ?
    'side' : 'over'" [opened]="isLargeScreen()"
    [opened]="drawerState$ | async">



    <ng-container *ngIf="searchSettings">
      <button mat-stroked-button class="w-100 mb-4" (click)="resetSearch();">Suche
        zurücksetzen</button>
        <!-- <mat-slide-toggle class="my-3" (change)="sortChange()">
          Sortierung: {{sortname}}
        </mat-slide-toggle> -->

      <ng-container *ngFor="let facetSetting of searchSettings.aggs">
        <!-- <div class="container">
          <h5 class="facet-title">{{ facetSetting.title }}</h5>
        </div> -->
        <ng-container *ngIf="facetSetting.title != 'Person'">
          <app-filter [type]="facetSetting.id"
            (selectionChange)="onSelectionChange($event)"
            [facetKeys]="facetSetting.facetKeys"
            [aggs]="facetDict[facetSetting.id]['values']" [terms]="facetDict"
            [isLoadingResults]="isLoadingResults"
            [title]="facetSetting.title">
          </app-filter>
        </ng-container>
      </ng-container>

      <div class="px-3">



        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mr-4 blue">calendar_month</mat-icon>
              Geburtsjahr
            </mat-panel-title>
            <mat-panel-description>
              <!-- This is a summary of the content -->
            </mat-panel-description>
          </mat-expansion-panel-header> 
                  


          <div class="form-inline">
            <mat-form-field class="mr-2">
              <input matInput maxlength="4" [(ngModel)]="date_von_year" (ngModelChange)="onChange()" (keydown.enter)="submitSearch();" placeholder="von" value="">
            </mat-form-field>
            <mat-form-field class="">
              <input matInput maxlength="4" [(ngModel)]="date_bis_year" (ngModelChange)="onChange()" (keydown.enter)="submitSearch();" placeholder="bis" value="">
            </mat-form-field>
          </div>

          <mat-slider class="w-100" [min]="min" [max]="max" step="1" showTickMarks discrete>
            <input matInput [(ngModel)]="date_von_year" (ngModelChange)="onChange()" matSliderStartThumb>
            <input matInput [(ngModel)]="date_bis_year" (ngModelChange)="onChange()" matSliderEndThumb>
          </mat-slider>
          
          <button *ngIf="!isActive" mat-raised-button class="w-100" (click)="submitRange()">
            Filter anwenden
          </button>
          
          <button *ngIf="isActive"mat-stroked-button  class="w-100" (click)="submitRange()">
            Filter aufheben
          </button>

        </mat-expansion-panel>



      </div>

   

    </ng-container>

  </mat-drawer>

  <mat-drawer-container autosize>

    <button class="my-2 anchor-button" (click)="toggleDrawer()" type="button" mat-icon-button	>
      <mat-icon [class.rotated]="isDrawerOpen">
          arrow_back_ios
      </mat-icon>
    </button>

    <mat-drawer position="start" #minimenu class="example-sidenav"
      [mode]="mobileQuery.matches ? 'over' : 'side'" color="primary">
      <div class="position-relative">

        <ul class="vida-sidemenu">


          <li class="p-3">
            <a target="_blank" href="http://uni-theme:8888/text-styles/">
              <button mat-icon-button>
                <mat-icon matTooltip="Dokumentation" aria-label="Example
                  icon-button with a heart icon">help</mat-icon>
              </button>
            </a>
          </li>
          <li class="p-3">
            <a target="_blank" href="http://uni-theme:8888/kontakt/">
              <button mat-icon-button>
                <mat-icon matTooltip="Melden Sie uns einen Fehler"
                  aria-label="Example icon-button with a heart icon">
                  feedback</mat-icon>
              </button>
            </a>
          </li>

        </ul>
      </div>
    </mat-drawer>

    <div class="container-fluid">


<div class="container">
  <app-text-search (search)="onTextSearch($event)"
  [facet_stadt]="facet_stadt"
  [facet_person]="facet_person"
  [count]="count"
  >
</app-text-search>
</div>
 

      <mat-paginator *ngIf="documents.length> 0" [length]="count"
        [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" (page)="pageEvent =
        getPaginatorData($event)">
      </mat-paginator>



    </div>
    <mat-divider></mat-divider>
    <div class="container-fluid px-0">

      <ul class="searchlist">

        <div *ngIf="!isLoadingResults" class="my-1"></div>
        <mat-progress-bar *ngIf="isLoadingResults" mode="indeterminate"></mat-progress-bar>
        <li *ngFor="let document of documents; let i = index"
        [ngClass]="{'grey': i % 2 === 1}">
        <app-list-item [document]="document"
          (infoRequest)="onInfoRequest($event)"></app-list-item>
      </li>

      </ul>
    </div>

    <mat-paginator *ngIf="documents.length> 0" [length]="count"
      [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" (page)="pageEvent =
      getPaginatorData($event)">
    </mat-paginator>
  </mat-drawer-container>
</mat-drawer-container>